// extracted by mini-css-extract-plugin
module.exports = {"globalbanner":"styles_globalbanner__2vy4P","headline":"styles_headline__3LKtw","cta":"styles_cta__3fYEv"};